import { lumiApi } from "../index";

export const projectsApi = lumiApi.injectEndpoints({
    endpoints: (build) => ({
        getVolumesOutliers: build.mutation({
            queryFn: async (
                {
                    id,
                    concept_selector,
                    conceptListId,
                    match_type = "both",
                    filter = [],
                    scoreField,
                    sentimentDisabled,
                    limit = 5,
                    buckets,
                },
                _queryApi,
                _extraOptions,
                baseQuery
            ) => {
                const specialFilter = { special: "outliers" };
                const outliersResponse = await baseQuery({
                    url: `/projects/${id}/concepts/outliers/`,
                    method: "POST",
                    body: {
                        concept_selector: {
                            type: "concept_list",
                            concept_list_id: conceptListId,
                        },
                        match_type,
                    },
                });
                if (outliersResponse?.error) {
                    return { error: outliersResponse.error };
                }
                const body = {
                    concept_selector,
                    filter: [...filter, specialFilter],
                    buckets,
                };
                const results = {};
                const promiseRequests = [
                    {
                        key: "volumes",
                        promise: baseQuery({
                            url: `/projects/${id}/concepts/match_counts`,
                            method: "POST",
                            body,
                        }),
                    },
                ];
                if (!sentimentDisabled) {
                    promiseRequests.push({
                        key: "sentiment",
                        promise: baseQuery({
                            url: `/projects/${id}/concepts/sentiment`,
                            method: "POST",
                            body,
                        }),
                    });
                }
                if (scoreField) {
                    const driversBody = { ...body, score_field: scoreField };
                    promiseRequests.push({
                        key: "drivers",
                        promise: baseQuery({
                            url: `/projects/${id}/concepts/score_drivers`,
                            method: "POST",
                            body: driversBody,
                        }),
                    });
                }
                const responses = await Promise.all(
                    promiseRequests.map((pr) => pr.promise)
                );
                responses.forEach((response, index) => {
                    const key = promiseRequests[index].key;
                    if (response.error) {
                        results[key] = { error: response.error };
                    } else {
                        results[key] = response.data;
                    }
                });
                return { data: results };
            },
        }),
    }),
});

export const { useGetVolumesOutliersMutation } = projectsApi;
